<template>
  <OMap :height="200" ref="theMap" />
</template>

<script>
import mapUtils from 'map-utils'
import DirectedPath from './DirectedPath'
import HeartbeatCircle from './HeartbeatCircle'

export default {
  components: {
    OMap: require('oderon-vue/maps/OMap').default
  },
  props: {
    heartbeats: { type: Array },
    highlighted: {}
  },
  mounted() {
    let omap = this.$refs.theMap
    omap.clear()
    this.directedPath = new DirectedPath(omap)
    this.highlightCircle = new HeartbeatCircle(omap)
  },
  watch: {
    heartbeats: function(hbs) {
      // reverse porque a lista vem com os mais recentes
      // primeiro, e queremos que a linha termine (isto é,
      // tenha a seta) no mais recente.
      let points = mapUtils.getValidPoints(hbs).reverse()
      this.directedPath.setPoints(points)
      this.$refs.theMap.fitPoints(points)
    },
    highlighted: function(hb) {
      if (hb != null) {
        let point = mapUtils.newLatLng(hb),
          flags = hb.summary
        this.highlightCircle.setPosition(point).setColor(flags)
      }
    }
  }
}
</script>

<style></style>
